(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5934],{

/***/ 65934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./src/components/Link.jsx
var Link = __webpack_require__(305);
// EXTERNAL MODULE: ./src/components/ListLink/ListLink.module.scss
var ListLink_module = __webpack_require__(35347);
var ListLink_module_default = /*#__PURE__*/__webpack_require__.n(ListLink_module);
;// CONCATENATED MODULE: ./src/components/ListLink/ListLink.jsx







var ListLink = function(props) {
    var attrs;
    if (props.external) {
        attrs = {
            target: "_blank",
            rel: "noopener"
        };
    }
    var linkTitle = props.title ? props.title : "";
    var colorClass = props.type || (ListLink_module_default()).darkgray; // default to darkgray if no type is supplied
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: classnames_default()((ListLink_module_default()).list, props.className),
        id: props.id,
        children: /^https?:\/\//.test(props.to) || props.contact ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: classnames_default()((ListLink_module_default()).anchor, colorClass),
            href: props.to
        }, attrs), {
            title: linkTitle,
            children: props.children
        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            className: classnames_default()((ListLink_module_default()).anchor, colorClass),
            to: props.to,
            title: linkTitle,
            children: props.children
        })
    });
};
ListLink.Type = {
    DARKBLUE: (ListLink_module_default()).darkblue,
    GRAY: (ListLink_module_default()).gray,
    DARKGRAY: (ListLink_module_default()).darkgray,
    WHITE: (ListLink_module_default()).white,
    BLACK_BOLD: (ListLink_module_default()).blackBold
};
ListLink.propTypes = {
    type: (prop_types_default()).string,
    className: (prop_types_default()).string,
    id: (prop_types_default()).string,
    external: (prop_types_default()).bool,
    to: (prop_types_default()).string,
    contact: (prop_types_default()).bool,
    children: (prop_types_default()).node
};
/* harmony default export */ var ListLink_ListLink = (ListLink);

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../@hiredigital/ui/src/Logo/Logo.module.scss
var Logo_module = __webpack_require__(20110);
var Logo_module_default = /*#__PURE__*/__webpack_require__.n(Logo_module);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Logo/svg/ref.inline.svg
var _use;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRefinline = function SvgRefinline(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 80"
  }, props), _use || (_use = /*#__PURE__*/react.createElement("use", {
    href: "#logo",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

/* harmony default export */ var ref_inline = (SvgRefinline);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Logo/RefLogo.jsx








var Logo = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var className = _param.className, type = _param.type, _site = _param.site, site = _site === void 0 ? "1" : _site, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "type",
        "site"
    ]);
    var logoSize = site === "2" ? (Logo_module_default()).hdLogo : (Logo_module_default()).hdMarketingLogo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ref_inline, (0,_object_spread/* default */.Z)({
        className: classnames_default()(logoSize, className, type)
    }, props));
});
Logo.propTypes = {
    className: (prop_types_default()).string,
    type: (prop_types_default()).string
};
Logo.Type = {
    WHITE: (Logo_module_default()).white,
    BLACK: (Logo_module_default()).black,
    BLUE: (Logo_module_default()).blue,
    DARKBLUE: (Logo_module_default()).darkblue,
    DARKGRAY: (Logo_module_default()).darkgray
};
/* harmony default export */ var RefLogo = (Logo);

// EXTERNAL MODULE: ./src/components/Footer/Footer.module.scss
var Footer_module = __webpack_require__(7190);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./src/components/Footer/Nav.jsx




var FooterNav = /*#__PURE__*/ (0,react.memo)(function(param) {
    var className = param.className, title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: (Footer_module_default()).navTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (Footer_module_default()).navItem,
                children: children
            })
        ]
    });
});
FooterNav.propTypes = {
    title: (prop_types_default()).string,
    children: (prop_types_default()).node
};
/* harmony default export */ var Nav = (FooterNav);

;// CONCATENATED MODULE: ./src/components/Svg/Facebook.jsx


var Facebook = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: props.className,
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z"
        })
    });
};
Facebook.propTypes = {
    className: (prop_types_default()).string
};
/* harmony default export */ var Svg_Facebook = (Facebook);

;// CONCATENATED MODULE: ./src/components/Svg/Linkedin.jsx


var Linkedin = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: props.className,
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M186.4 142.4c0 19-15.3 34.5-34.2 34.5 -18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5C171.1 107.9 186.4 123.4 186.4 142.4zM181.4 201.3h-57.8V388.1h57.8V201.3zM273.8 201.3h-55.4V388.1h55.4c0 0 0-69.3 0-98 0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9 0 26.9 0 98 0 98h57.5c0 0 0-68.2 0-118.3 0-50-28.3-74.2-68-74.2 -39.6 0-56.3 30.9-56.3 30.9v-25.2H273.8z"
        })
    });
};
Linkedin.propTypes = {
    className: (prop_types_default()).string
};
/* harmony default export */ var Svg_Linkedin = (Linkedin);

;// CONCATENATED MODULE: ./src/components/Svg/Twitter.jsx


var Twitter = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: props.className,
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z"
        })
    });
};
Twitter.propTypes = {
    className: (prop_types_default()).string
};
/* harmony default export */ var Svg_Twitter = (Twitter);

;// CONCATENATED MODULE: ./data/contact.js
var locales = [
    {
        locale: "us",
        city: "New York",
        phone: "+1 (646) 849-6260",
        email: "contact@hiredigital.com"
    },
    {
        locale: "sg",
        city: "Singapore",
        phone: "+65 6910 8567",
        email: "contact@hiredigital.com"
    },
    {
        locale: "none",
        city: "",
        phone: "",
        email: "contact@hiredigital.com"
    }, 
];


;// CONCATENATED MODULE: ./src/components/Footer/Footer.jsx












var Footer = /*#__PURE__*/ (0,react.memo)(function(param) {
    var darkFooter = param.darkFooter, data = param.data, locale = param.locale, footer = param.footer, className = param.className;
    var selectedLocale = locales.find(function(l) {
        return l.locale === locale;
    }) || data;
    // const copyright = `Copyright © 2021. Hire Digital`;
    var listLinkType = darkFooter ? ListLink_ListLink.Type.WHITE : ListLink_ListLink.Type.DARKGRAY;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: classnames_default()((Footer_module_default()).wrapper, darkFooter ? (Footer_module_default()).darkblue : className ? className : (Footer_module_default()).defaultBackground),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Footer_module_default()).sitemap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((Footer_module_default()).container, (Footer_module_default()).containerTop),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Footer_module_default()).description,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RefLogo, {
                                    className: (Footer_module_default()).logo,
                                    type: darkFooter ? RefLogo.Type.WHITE : RefLogo.Type.DARKGRAY,
                                    site: "3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (Footer_module_default()).descriptionText,
                                    children: "Hire Digital helps businesses build and enhance their digital capabilities with a world-class network of digital marketers, developers, and designers. Clients leverage on-demand teams to gain control of key priorities, plan their seasonal resources, and launch pilots to success."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Footer_module_default()).flexSpacer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav, {
                            title: "Solutions",
                            className: (Footer_module_default()).footerNav,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/clients",
                                    children: "Clients"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/enterprise",
                                    children: "Enterprise"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/talent",
                                    children: "Become a Talent"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav, {
                            title: "Resources",
                            className: (Footer_module_default()).footerNav,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/blog",
                                    children: "Blog"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/resources",
                                    children: "Resources"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/faq",
                                    children: "FAQ"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/terms",
                                    children: "Terms"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/privacy",
                                    children: "Privacy"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav, {
                            title: "Company",
                            className: (Footer_module_default()).footerNav,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/about",
                                    external: true,
                                    children: "About"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/contact",
                                    children: "Contact"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLink_ListLink, {
                                    type: listLinkType,
                                    className: (Footer_module_default()).navLink,
                                    to: "/careers",
                                    children: "Careers"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Footer_module_default()).contact, (Footer_module_default()).container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Footer_module_default()).section,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((Footer_module_default()).contactLink),
                            href: selectedLocale ? "mailto:".concat(selectedLocale.email) : "mailto:".concat("contact@hiredigital.com"),
                            title: "Enquiry",
                            children: selectedLocale ? selectedLocale.email : "contact@hiredigital.com"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Footer_module_default()).section,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: classnames_default()((Footer_module_default()).contactLink),
                            href: "tel:".concat((footer === null || footer === void 0 ? void 0 : footer.internationalNumber) || (selectedLocale === null || selectedLocale === void 0 ? void 0 : selectedLocale.phone) || "+1 (617) 528-0943"),
                            title: "phone",
                            children: (footer === null || footer === void 0 ? void 0 : footer.internationalNumber) || (selectedLocale === null || selectedLocale === void 0 ? void 0 : selectedLocale.phone) || "+1 (617) 528-0943"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((Footer_module_default()).section, (Footer_module_default()).rightSection),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (Footer_module_default()).linkIcon,
                                href: "".concat("https://www.facebook.com/hiredigitalco"),
                                rel: "noopener noreferrer nofollow me",
                                title: "Hire Digital Facebook",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Facebook, {
                                    className: (Footer_module_default()).icon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (Footer_module_default()).linkIcon,
                                href: "".concat("https://twitter.com/hiredigital1"),
                                rel: "noopener noreferrer nofollow me",
                                title: "Hire Digital Twitter",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Twitter, {
                                    className: (Footer_module_default()).icon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (Footer_module_default()).linkIcon,
                                href: "".concat("https://sg.linkedin.com/company/hiredigitalco"),
                                rel: "noopener noreferrer nofollow me",
                                title: "Hire Digital LinkedIn",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Linkedin, {
                                    className: (Footer_module_default()).icon
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
Footer.propTypes = {
    darkFooter: (prop_types_default()).bool,
    data: (prop_types_default()).object,
    locale: (prop_types_default()).string
};
/* harmony default export */ var Footer_Footer = (Footer);


/***/ }),

/***/ 7190:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__fRar6","container":"Footer_container__Vebor","navLink":"Footer_navLink__MNbUa","flexSpacer":"Footer_flexSpacer__nFzkD","footerNav":"Footer_footerNav__LFrAZ","navTitle":"Footer_navTitle__OQTKB","navItem":"Footer_navItem__dowtJ","defaultBackground":"Footer_defaultBackground__Y4CL6","sitemap":"Footer_sitemap__MmTOv","containerTop":"Footer_containerTop__QqBpp","darkblue":"Footer_darkblue__ptnMb","copyright":"Footer_copyright__waMAS","descriptionText":"Footer_descriptionText__3S_sK","contactLink":"Footer_contactLink__cuRcn","link":"Footer_link__Eo6xs","icon":"Footer_icon__UBU7R","logo":"Footer_logo__EaWBg","contact":"Footer_contact__M1krk","section":"Footer_section__IiWJL","linkIcon":"Footer_linkIcon__9O94N","description":"Footer_description__M7TCR"};

/***/ }),

/***/ 35347:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"ListLink_list__glUn_","anchor":"ListLink_anchor__SOLh5","darkblue":"ListLink_darkblue___cz_r","darkgray":"ListLink_darkgray__Cc5Zz","gray":"ListLink_gray__372vW","white":"ListLink_white__t3k74","blackBold":"ListLink_blackBold__adnxE"};

/***/ })

}]);